export const loadAnalytics = (options) => ({
  type: `ANALYTICS_${options.type}`,
  store_id: options.store_id,
  request: {
    url: '/Analytics',
    method: 'POST',
    data: options,
  },
});
